// package: cbv1
// file: proto/cybertron/drivercertification/driverCertification_api.proto

var proto_cybertron_drivercertification_driverCertification_api_pb = require("../../../proto/cybertron/drivercertification/driverCertification_api_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var DriverCertificationAPI = (function () {
  function DriverCertificationAPI() {}
  DriverCertificationAPI.serviceName = "cbv1.DriverCertificationAPI";
  return DriverCertificationAPI;
}());

DriverCertificationAPI.GetDriverCertifications = {
  methodName: "GetDriverCertifications",
  service: DriverCertificationAPI,
  requestStream: false,
  responseStream: false,
  requestType: proto_cybertron_drivercertification_driverCertification_api_pb.GetDriverCertificationsRequest,
  responseType: proto_cybertron_drivercertification_driverCertification_api_pb.GetDriverCertificationsResponse
};

exports.DriverCertificationAPI = DriverCertificationAPI;

function DriverCertificationAPIClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

DriverCertificationAPIClient.prototype.getDriverCertifications = function getDriverCertifications(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(DriverCertificationAPI.GetDriverCertifications, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.DriverCertificationAPIClient = DriverCertificationAPIClient;

